import { spawn } from 'redux-saga/effects';

import { sagas as summarySagas } from './summaryModule';

export default function* sagas() {
	yield spawn(summarySagas);
}
